<template>
<div class="chapter">
<div class="inner_page">
<p class="ct"><a href="#/contents#c4k" id="c04k">Image Gallery</a></p>
<p class="ser"><img alt="img" src="images/flo.jpg"/></p>
<p class="tx1">The following images are pages from an 18<sup>th</sup> century illuminated Haggadah that illustrates events in the life of Moses from the biblical book of Exodus, one of the original Five Books of Moses that began as the Torah.<br/><br/></p>
<p class="tx1">A Haggadah is a collection of Jewish prayers and readings written to accompany the Passover <i>seder</i>, a ritual meal eaten on the eve of the Passover festival. The literal meaning of the Hebrew word Haggadah is a “narration” or “telling.” It refers to a command in Exodus, requiring Jews to “tell your son on that day: it is because of that which the Lord did for me when I came forth out of Egypt.”</p>
<p class="ser"><img alt="img" src="images/img1.jpg"/></p>
<p class="cap"><span>Hamburg Haggadah, 1731; Created by Ya’akov ben Yehuda Leyb, Sofer (Scribe); Black and gold ink and gray wash on vellum; 31 cm; Courtesy of The New York Public Library. <a href="http://www.nypl.org" target="_blank">www.nypl.org</a></span></p>
<p class="txc"><span>Pharaoh’s daughter went down to the Nile to bathe.</span></p>
<p class="ser"><img alt="img" src="images/img2.jpg"/></p>
<p class="cap"><span>Hamburg Haggadah, 1731; Created by Ya’akov ben Yehuda Leyb, Sofer (Scribe); Black and gold ink and gray wash on vellum; 31 cm; Courtesy of The New York Public Library. <a href="http://www.nypl.org" target="_blank">www.nypl.org</a></span></p>
<p class="txc"><span>Egypt: Israelites build cities of Pithom and Ramses, right, and left, Moses slays an Egyptian.</span></p>
<p class="ser"><img alt="img" src="images/img3.jpg"/></p>
<p class="cap"><span>Hamburg Haggadah, 1731; Created by Ya’akov ben Yehuda Leyb, Sofer (Scribe); Black and gold ink and gray wash on vellum; 31 cm; Courtesy of The New York Public Library. <a href="http://www.nypl.org" target="_blank">www.nypl.org</a></span></p>
<p class="txc"><span>They said to Pharaoh, “Thus says the Lord: Let my people go.”</span></p>
<p class="ser"><img alt="img" src="images/img4.jpg"/></p>
<p class="cap"><span>Hamburg Haggadah, 1731; Created by Ya’akov ben Yehuda Leyb, Sofer (Scribe); Black and gold ink and gray wash on vellum; 31 cm; Courtesy of The New York Public Library. <a href="http://www.nypl.org" target="_blank">www.nypl.org</a></span></p>
<p class="txc"><span>And the Lord drowned Egypt while Israel walked on dry land in the middle of the sea.</span></p>
<p class="ser"><img alt="img" src="images/img5.jpg"/></p>
<p class="cap"><span>Hamburg Haggadah, 1731; Created by Ya’akov ben Yehuda Leyb, Sofer (Scribe); Black and gold ink and gray wash on vellum; 31 cm; Courtesy of The New York Public Library. <a href="http://www.nypl.org" target="_blank">www.nypl.org</a></span></p>
<p class="txc"><span>Moses would speak and God would respond aloud; and the people said, “All that the Lord has decreed, we undertake to do.”</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// image.vue?0e766533